import React from "react";
import Item from "./Item";
import {Accordion} from "react-bootstrap";
import {VertHotelConference, danHotelConference, Events} from "../items";
import EilatConferencesAccordion from "./EilatConferenceAccordion";

const ConferencesAndEventsAccordion = () => {
    return (
        <div>
            <Accordion style={{direction: "rtl"}}>
                <div style={{marginTop: "1px"}}>
                    <Item items={Events.items} eventKey="0"/>
                    <Item items={VertHotelConference.items} eventKey="1"/>
                </div>
                <Accordion.Header style={{marginTop: "1px"}}>כנס איגוד אילת 2026</Accordion.Header>
                <Accordion.Body>
                    <EilatConferencesAccordion/>
                </Accordion.Body>
                <div style={{marginTop: "1px"}}>
                    <Item items={danHotelConference.items} eventKey="2"/>
                </div>
            </Accordion>
        </div>
    )
}

export default ConferencesAndEventsAccordion